import React from "react";
import * as RadixDialog from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import "./Dialog.css";

export function Dialog({ open, onOpenChange, children }) {
  return (
    <RadixDialog.Root open={open} onOpenChange={onOpenChange}>
      {children}
    </RadixDialog.Root>
  );
}

export const DialogTrigger = RadixDialog.Trigger;
export const DialogClose = RadixDialog.Close;

export function DialogContent({
  size = "md",
  side = null, // null = centered modal, "right" | "left" | "bottom" = drawer
  showClose = true,
  title,
  description,
  className = "",
  children,
  ...props
}) {
  return (
    <RadixDialog.Portal>
      <RadixDialog.Overlay className="ui-dialog-overlay" />
      <RadixDialog.Content
        className={`ui-dialog-content ${side ? `ui-dialog-side ui-dialog-side-${side}` : `ui-dialog-modal ui-dialog-${size}`} ${className}`}
        {...props}
      >
        {(title || description || showClose) && (
          <div className="ui-dialog-head">
            <div className="ui-dialog-head-text">
              {title && <RadixDialog.Title className="ui-dialog-title">{title}</RadixDialog.Title>}
              {description && (
                <RadixDialog.Description className="ui-dialog-desc">{description}</RadixDialog.Description>
              )}
            </div>
            {showClose && (
              <RadixDialog.Close className="ui-dialog-close" aria-label="Cerrar">
                <X size={18} />
              </RadixDialog.Close>
            )}
          </div>
        )}
        {children}
      </RadixDialog.Content>
    </RadixDialog.Portal>
  );
}

export function DialogBody({ children, className = "", ...props }) {
  return <div className={`ui-dialog-body ${className}`} {...props}>{children}</div>;
}

export function DialogFooter({ children, className = "", ...props }) {
  return <div className={`ui-dialog-footer ${className}`} {...props}>{children}</div>;
}
